<template>
  <div v-show="show">
    <!-- 固定按钮开始 -->
    <template>
      <template v-if="h5Geted[0]">
        <a
          href="javascript:;"
          class="actModules_actionBtn actModules_actionBtnTips"
        >
          <span v-text="tabItems[0].buttonName2"></span>
        </a>
      </template>
      <template v-else>
        <a href="javascript:;" class="actModules_actionBtn" @click="open()">
          <span v-text="tabItems[0].buttonName1"></span>
        </a>
      </template>
      <div class="bottom">
        <div ref="tips">
          <p>填写手机号码,后续接收活动提醒</p>
          <input type="text" placeholder="请输入11位手机号" v-model="text" />
        </div>
        <div ref="success">
          <span>{{ tabItems[0].success_text }}</span>
        </div>
      </div>
    </template>
    <!-- 弹窗开始-->
    <!-- 弹窗结束-->
  </div>
</template>

<script>
import bus from '../../../bus';
import { buryingPoint } from '../buryingPoint/makeanAppointment';
export default {
	name: 'h5-orderBtn',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			tabItems: '预约',
			action: 'app动作',
			h5Action: 'h5动作',
			buttonName1: '预约文案',
			buttonName2: '已预约文案',
			success_head: '预约成功后头部文案',
			success_text: '预约成功后提示文案',
			queryButton: '预约状态查询',
			showtype: '展示(1安卓,0 IOS)'
		}
	},
	props: {
		tabItems: {
			type: Array,
			default () {
				return [
					{
						action: {
							class: 'action',
							type: 'subscribe', // ams link alert
							value: '', //
							ruleId: ''
						},
						h5Action: {
							class: 'action',
							type: 'subscribe', // ams link alert
							value: '', //
							ruleId: ''
						},
						buttonName1: '立即预约',
						buttonName2: '已预约',
						success_head: '恭喜你，成功预约',
						success_text: '你已成功预约'
					}
				];
			}
		},
		queryButton: {
			type: Array,
			default: () => [
				{
					h5Action: {
						class: 'action',
						type: 'no', // ams link alert
						value: '', //
						ruleId: ''
					}
				}
			]
		},
		showtype: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			geted: [false],
			h5Geted: [false],
			text: '',
			show: true
		};
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		bus.$on('getBookQuota', status => {
			this.query();
		});
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
	},
	methods: {
		doAction () {
			if (this.$actMode !== 'production') {
				return;
			}
			if (!window.Tgclub || !window.Tgclub.getAppChannelInfo) {
				alert('请前往心悦APP参加该活动');
			}
		},
		async query () {
			try {
				const [
					{
						h5Action: { value }
					}
				] = this.queryButton;
				const data = {
					...window.bindInfo,
					sServiceType: this.$actConfig.gameCode
				};
				const {
					res: { sOutValue1 }
				} = await this.$doAction('ame', value, data);
				if (sOutValue1 === '1') {
					this.$set(this.h5Geted, 0, true);
				}
			} catch (e) {
				console.log(e);
			}
		},
		receiveGift () {
			const [
				{
					h5Action: { value }
				}
			] = this.tabItems;
			let commid = window.milo.cookie.get('commid');
			const data = {
				...window.bindInfo,
				phoneNumber: this.text,
				commid,
				sServiceType: this.$actConfig.gameCode
			};
			this.$doAction('ame', value, data)
				.then(({ jData: { status } }) => {
					if (status === 0) {
						this.$set(this.h5Geted, 0, true);
						buryingPoint(this.modulesTitle, this.$axios);
						this.close();
					}
				})
				.catch(err => {
					console.log(err);
					alert(err.sMsg);
				});
		},
		open () {
			window.need('util.modalDialog', Dialog => {
				Dialog.alert(this.$refs.tips, {
					title: '填写预约信息',
					confirmTitle: '进行预约',
					onConfirm: () => {
						if (/^1[3456789]\d{9}$/.test(this.text)) {
							this.receiveGift();
						} else {
							alert('请输入正确手机号');
							return false;
						}
					},
					onCancel: () => {
						console.log('关闭');
					}
				});
			});
		},
		close () {
			window.need('util.modalDialog', Dialog => {
				Dialog.alert(this.$refs.success, {
					title: this.tabItems[0].success_head,
					onConfirm: () => {
						console.log('关闭');
					}
				});
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common";
.actModules_actionBtn {
  @extend %block;
  height: 1.28rem;
  width: 7.5rem;
  background: #e27f7f;
  color: #4a4a4a;
  font-size: 0.4rem;
  @extend %box;
  /*! autoprefixer: off */
  -webkit-box-align: center;
  box-align: center;
  -webkit-box-pack: center;
  box-pack: center;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  /* autoprefixer: on */
  //   @extend %fixed;
  left: 0;
  bottom: 0;
  margin: 0 auto;
}
.actModules_actionBtnTips {
  font-size: 0.26rem;
  color: #4a4a4a;
  @extend %block;
  line-height: 1.2;
}

.actModules_DownLoadBar {
  width: 1.6rem;
  @extend %inline-block;
  height: 0.3rem;
  vertical-align: middle;
  background: #4a4a4a;
  font-size: 0.24rem;
  font-style: normal;
  color: #fff;
  text-align: center;
  @extend %relative;
}

.actModules_DownLoadBarProcess {
  @extend %block;
  height: 100%;
  @extend %absolute;
  left: 0;
  top: 0;
  background: #e27f7f;
  border: 1px solid #4a4a4a;
}

.actModules_DownLoadPercent {
  @extend %relative;
  z-index: 10;
}

.actModal_footer {
  text-align: center;
}
.actModal_footerBtn {
  height: 0.7rem;
  line-height: 0.7rem;
  width: 2.4rem;
  background: #e27f7f;
  @extend %inline-block;
  font-size: 0.28rem;
  color: #4a4a4a;
  margin: 0.34rem 0.16rem 0;
}

.actModal {
  width: 100%;
  height: 100%;
  @extend %fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 6000;
}

.actModal_content {
  width: 6.2rem;
  @extend %absolute;
  left: 50%;
  top: 50%;
  @include translate(-50%, -50%);
  background: #fff;
  padding-bottom: 0.44rem;
  border: 1px solid #979797;
}

.actModal_closeBtn {
  height: 0.5rem;
  width: 0.5rem;
  @extend %block;
  @extend %absolute;
  right: 0.28rem;
  top: 0.24rem;

  span {
    @extend %block;
    width: 0.3rem;
    height: 0.3rem;
    background: #e27f7f;
    @extend %absolute;
    left: 50%;
    top: 50%;
    @include translate();
  }
}

.actModal_bodyTitle {
  font-size: 0.3rem;
  color: #4a4a4a;
  text-align: center;
  margin: 0.5rem 0.8rem 0;
}

.actModal_bodyInput {
  width: 5.3rem;
  margin: 0.18rem auto;

  input {
    padding-left: 0.2rem;
    font-size: 0.24rem;
    width: 100%;
    @include border-radius(8px);
    border: 1px solid #4a4a4a;
    @extend %block;
  }

  &.phoneNum {
    input {
      height: 0.8rem;
    }
  }

  &.awards {
    margin-top: 0.3rem;
    margin-bottom: 0.06rem;

    input {
      height: 0.5rem;
      text-align: center;
    }
  }
}

.actModal_bodyDescribe {
  color: #4a4a4a;
  text-align: center;
  font-size: 0.2rem;
}
.bottom {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/bottomBtn/orderBtn.vue